import { render, staticRenderFns } from "./CreatePresetButtonPreview.vue?vue&type=template&id=a84d1cae&scoped=true"
import script from "./CreatePresetButtonPreview.vue?vue&type=script&lang=js"
export * from "./CreatePresetButtonPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84d1cae",
  null
  
)

export default component.exports